import { AnimatePresence } from 'motion/react';
import OrderCard from './OrderCard';

export default function OrderStream({ groups, onStatusChange, stationFilter = 'all' }) {
  return (
    <section className="service-panel service-stream-panel">
      <div className="service-panel-head">
        <div>
          <h2>Comandas activas</h2>
          <p>Ordenadas por mesa y urgencia de servicio.</p>
        </div>
      </div>

      <div className="service-order-stream">
        {groups.length === 0 && (
          <div className="service-empty">
            <h3>Sin comandas pendientes</h3>
            <p>Cuando entre un pedido desde una mesa aparecerá aquí en tiempo real.</p>
          </div>
        )}

        {groups.map((group) => (
          <section key={group.table?._id || group.key} className="service-order-group">
            <div className="service-order-group-head">
              <strong>Mesa {group.table?.number || '?'}</strong>
              <span>{group.orders.length} comandas</span>
            </div>
            <AnimatePresence initial={false}>
              {group.orders.map((order) => (
                <OrderCard
                  key={order._id}
                  order={order}
                  table={group.table}
                  onStatusChange={onStatusChange}
                  stationFilter={stationFilter}
                />
              ))}
            </AnimatePresence>
          </section>
        ))}
      </div>
    </section>
  );
}
